import { render, staticRenderFns } from "./VisualizarPaciente.vue?vue&type=template&id=7a9e638b&"
import script from "./VisualizarPaciente.vue?vue&type=script&lang=js&"
export * from "./VisualizarPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports